import { store } from '@shared/store/store';
import { Url } from '@shared/types/interfaces/config';
import axios, { CancelTokenSource } from 'axios';
import endpoints from '../api/endpoints.json';
import ApiConfig from '@api';
import ApiRequestParams from '@shared/types/interfaces/api';
import FlavourConfig from '@shared/config/flavours';
import DeviceConfig from '@devices/config';
import User from '@shared/classes/user';

const ApiUtils = {
  getConfig: ({
    abort = false,
    controller,
    customHeaders,
    endpoint,
    headers,
  }: ApiRequestParams & {
    controller: CancelTokenSource;
    customHeaders: { header: string; value: string }[];
  }) => {
    if (abort) {
      controller.cancel('Override request');
      controller = axios.CancelToken.source();
    }
    const { user } = store.getState();
    const { url } = endpoint || { url: 'cdnSyncUrl' };
    const cancelToken = abort ? controller.token : undefined;
    const acceptHeaders = url && url !== 'cdnSyncUrl';

    const headerParams: { [key: string]: string } = {};
    if (acceptHeaders) {
      headerParams['x-access-token' as string] = user?.token || '';
      headerParams['x-tvup-platform'] = 'SMARTTV';
      headerParams['x-tvup-device'] = DeviceConfig.info.uuid;
      headerParams['x-tvup-planid'] =
        User.getPlan(user.planId || null)?.id || '';
      if (headers?.length || customHeaders?.length) {
        [...customHeaders, ...(headers || [])].forEach((item) => {
          headerParams[item.header] = item.value;
        });
      }
    }

    return {
      cancelToken,
      headers: headerParams,
    };
  },
  getUrl: (url?: Url) => {
    const { app } = store.getState();
    return url
      ? app.urls[url] ||
          ApiConfig.urls.app[url as keyof typeof ApiConfig.urls.app] ||
          ''
      : '';
  },
  parseUrl: ({ endpoint }: ApiRequestParams) => {
    const { user } = store.getState();
    const { url, version, section, subsection, type, params, replacement } =
      endpoint;

    const parsedUrl = [ApiUtils.getUrl(url)];

    if (version) parsedUrl.push(version);
    if (section?.length) parsedUrl.push(section);
    if (subsection?.length) parsedUrl.push(subsection);
    if (type?.length)
      parsedUrl.push(
        endpoints[(section || '') as ''][(subsection || '') as ''][
          (type || '') as ''
        ]
      );

    return (parsedUrl.join('/') + (params || ''))
      .replace('{carrier}', user?.carrierId || FlavourConfig.carrierId)
      .replace('{replacement}', replacement || '');
  },
};

export default ApiUtils;
